import { ReactNode, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@material-ui/core";
import { TrainerContainer } from "../styles";
import { TrainerForm } from "./TrainerForm";
import { ErrorMessageSnackbar } from "../../shared/ErrorMessageSnackbar/ErrorMessageSnackbar";
import { LoadingProgressOverlay } from "../../shared/LoadingProgress/LoadingProgressOverlay";
import { initialTrainerData, TrainerContext } from "../context";
import { Trainer, useGetDraftTrainerLazyQuery } from "../../../generated/graphql";

export const TrainerWrapper = ({ children }: { children: ReactNode }) => {
    const { trainerId } = useParams<{ appId: string, trainerId: string }>();
    const [trainerData, setTrainerData] = useState<Trainer>(initialTrainerData);
    const [hasError, setHasError] = useState(false);

    const [ getDraftTrainer, { loading }]= useGetDraftTrainerLazyQuery();
    
    useEffect(() => {
        if (trainerId) {
            getDraftTrainer({
                variables: { trainerId },
                onCompleted: (data) => {
                    if (data.getDraftTrainer) {
                        setTrainerData(data.getDraftTrainer);
                        return;
                    };
                    setHasError(true);
                },
                onError: () => {
                  setHasError(true);
                },
                fetchPolicy: "cache-and-network",
            });
        }
    }, [trainerId]);
    
    const updateTrainerData = (key: string, value: string | number | File) => {
        setTrainerData((prevData) => ({
            ...prevData,
            [key]: value,
        }));
    };

    return (
        <TrainerContext.Provider value={{ data: trainerData, updateTrainerData }}>
            <Container maxWidth="lg">
                {children}
                <TrainerContainer elevation={6}>
                    <TrainerForm />
                </TrainerContainer>
                <ErrorMessageSnackbar
                    open={hasError}
                    message="Сталась помилка при завантаженні даних тренажера"
                    closeHandler={() => setHasError(false)}
                />
                {loading && <LoadingProgressOverlay />}
            </Container>
        </TrainerContext.Provider>    
    );
};
